import { z } from 'zod';

export const createClientNoteSchema = z.object({
  content: z.string().min(1, 'Note content is required').max(5000),
});

export const updateClientNoteSchema = createClientNoteSchema;

export type CreateClientNoteInput = z.infer<typeof createClientNoteSchema>;
export type UpdateClientNoteInput = z.infer<typeof updateClientNoteSchema>;
